var React = require('react');

function GoodiesInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","fill":"none","stroke":"currentColor"},[React.createElement("path",{"strokeMiterlimit":"10","d":"M2 22L7 7l10 10-15 5z","key":0}),React.createElement("path",{"d":"M10 5l1-3M19 14l3-1M17 5a2 2 0 112-2 2 2 0 01-2 2zM23 3a6 6 0 01-6 6","key":1}),React.createElement("path",{"strokeMiterlimit":"10","d":"M4.762 13.714l2.21 6.629M7.786 7.786l3.685 11.057","key":2})]));
}

GoodiesInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = GoodiesInline;

GoodiesInline.default = GoodiesInline;
